import { useContext } from 'react';

import { SegmentContext } from 'context/SegmentContext';

export default function useSegment() {
  const context = useContext(SegmentContext);

  if (!context) {
    throw new Error('useSegment must be used within a SegmentProvider');
  }

  return context;
}
